
import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import BaseSubNavContainer from '@/containers/base/BaseSubNavContainer.vue'
import BaseListItemContainer from '@/containers/base/BaseListItemContainer.vue'
import {optionsVslim} from '@/config/v-slim-dialog'

const mailModule = namespace('mail')

@Component({
  components: {
    BaseSubNavContainer,
    BaseListItemContainer
  }
})
export default class ProspectSujet extends Vue {
  @mailModule.Action('getMailSujetsAction') getMailSujets: any
  @mailModule.Action('getMailSujetByIdAction') getMailSujetById: any
  @mailModule.Action('deleteMailSujetAction') deleteMailSujet: any
  @mailModule.Action('syncMailSujetAction') syncMailSujet: any
  @mailModule.Getter('mailSujetsGetter') mailSujets: any

  mounted() {
    this.getMailSujets()
  }

  changeOrder(data) {
    this.syncMailSujet(data)
  }

  async onDelete(id: number) {
    const {ok} = await this.$dialogs.confirm('Confirmez vous la suppression du sujet ?', optionsVslim)
    if (ok) {
      this.deleteMailSujet(id).then(async () => {
        this.getMailSujets()
      })
    }
  }
}
